module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUBAMAAABscEDKAAAAJFBMVEUAKGhlfaSHmritus+/ydnn6/HvKy31e3z3lZb6vb77xMX94uKXexcdAAAAMUlEQVQY02NIS0tLD2BalgYBDLTjdnR0dAYw7eiAAAYXIDBgdIECBvwATTGaUfTyAgDtrF+DpuEjUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/no.png
// module id = 900
// module chunks = 0